module.exports = __webpack_public_path__ + "static/media/ticket-02.2fd21bc4.svg";